module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/42.66fac4b0.png";